import type { UserObjectType } from "../../types/schema";

export const isUserAdmin = (user: UserObjectType | null): boolean => {
  if (!user) return false;
  return user.userType === "SUPERUSER";
};

export const canAccessStaffPortal = (user: UserObjectType | null): boolean => {
  if (!user) return false;
  // Allow both superusers and staff users
  return (
    user.userType === "SUPERUSER" ||
    user.userType === "STAFF" ||
    user.isEmployee === true ||
    user.isStaff === true
  );
};

export const isUserDataComplete = (user: UserObjectType | null): boolean => {
  if (!user) return false;

  // Check for essential fields that indicate complete profile
  return !!(
    user.id &&
    user.email &&
    user.firstName &&
    user.lastName &&
    "userType" in user &&
    "status" in user &&
    "isActive" in user &&
    "isMember" in user &&
    "isStaff" in user
  );
};

export const handleNonAdminUser = async (
  user: UserObjectType
): Promise<void> => {
  console.warn("Non-admin user detected:", {
    id: user.id,
    email: user.email,
    userType: user.userType,
  });
};
